import { Navigate, useSearchParams } from 'react-router-dom';
import { Spin } from '@arco-design/web-react';
import { useSelector } from 'react-redux';

import { readGuestIntakeRouteParams } from '../../constants/guestIntake';
import { useAuthSessionReady } from '../../hooks/useAuthSessionReady';
import { useEventIntakeEnabled } from '../../hooks/useEventIntakeEnabled';
import { routes } from '../../routes/routes';
import { RootState } from '../../store/store';
import { GuestIntakeConvertStep } from './GuestIntakeConvertStep';
import { GuestIntakeForm } from './GuestIntakeForm';

export const GuestIntakeRouteGuard = () => {
  const eventIntakeEnabled = useEventIntakeEnabled();
  const authReady = useAuthSessionReady();
  const configLoaded = useSelector((state: RootState) => state.config.configLoaded);
  const user = useSelector((state: RootState) => state.user.user);
  const [searchParams] = useSearchParams();
  const routeParams = readGuestIntakeRouteParams(searchParams);

  if (!configLoaded || !authReady) {
    return <Spin style={{ margin: '120px auto' }} size={32} />;
  }

  if (!eventIntakeEnabled) {
    return <Navigate to={routes.DASHBOARD} replace />;
  }

  if (!user) {
    return <Navigate to={routes.LOGIN} replace />;
  }

  if (!user.isGuest) {
    return <Navigate to={routes.DASHBOARD} replace />;
  }

  if (routeParams.step === 'convert' && user.guestIntakeCompleted) {
    return <GuestIntakeConvertStep initialRole={routeParams.role} />;
  }

  return <GuestIntakeForm highlightRoleChoice={routeParams.step === 'convert'} />;
};
